import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import { IOldUIContext } from "../../global"

import * as IncidentsSlice from "./slice"
import { IRCAFinding, IRootCauseAnalysisActions } from "."
import RootCauseAnalysis from "./components/RootCauseAnalysis"

interface StartProps extends IncidentsSlice.IInitializeRootCauseAnalysis {
    actions: IRootCauseAnalysisActions
}

interface OldUIInit {
    startRootCauseAnalysis: (elementSelector: string, props: StartProps) => void
    reloadData: (props: IRCAFinding[]) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const startRootCauseAnalysis = (
        elementSelector: string,
        props: StartProps,
    ): void => {
        // we cannot pass down an element, because this is called from an iframe custom view
        // but the container we should load into is not within an iframe
        const element = document.querySelector(elementSelector)
        if (!element) {
            // target container doesn't exist, skip initialization
            return
        }

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <RootCauseAnalysis {...props} />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const reloadData = (props: IRCAFinding[]): void => {
        store.dispatch(IncidentsSlice.loadData(props))
    }

    return {
        startRootCauseAnalysis,
        reloadData,
    }
}

export default init
